// ** Router Import
import Router from './router/Router'
import {useEffect, useState} from "react";
import {fixFooterButtons} from "./views/components/FooterButtons";
import {getUserData} from "./auth/utils";
import axios from "axios";

export function isMobile() {
    return window.innerWidth <= 800;
}


export function refreshUser() {
    return new Promise((resolve => {
        axios.get(`${process.env.REACT_APP_MAIN_URL}/get-current-user`).then((result) => {
            if (result.data.user != null && getUserData() != null) {
                let data = getUserData();
                data.userData = result.data.user
                data.role = result.data.user.role
                localStorage.setItem('userData', JSON.stringify(data))
                resolve();
            } else {
                resolve();
            }
        })
    }));
}


const App = (props) => {
    const [userRefreshed, setUserRefreshed] = useState(false);
    useEffect(() => {
        if (window.location.protocol !== 'https:' && !window.location.href.includes("localhost")) {
            window.location = 'https:' + window.location.href.substring(window.location.protocol.length)
            return;
        }
        if (getUserData() && getUserData().userData &&
            !window.location.href.includes("/login") &&
            !window.location.href.includes("/forgot-password") &&
            !window.location.href.includes("/reset-password") &&
            !window.location.href.includes("/terms-conditions") &&
            !window.location.href.includes("/privacy-policy") &&
            !window.location.href.includes("/register")) {
            refreshUser().then((result) => {
                setUserRefreshed(true);
            }).catch((e) => {
                setUserRefreshed(true);
            });
        } else {
            setUserRefreshed(true)
        }

        setTimeout(() => {
            let rowsPerTable = document.getElementsByClassName("sc-fznxKY sc-fznWOq ncoBp");
            for (let i = 0; i < rowsPerTable.length; i++) {
                rowsPerTable[i].innerHTML = "Redaka po stranici"
            }
            window.addEventListener("resize", () => {
                fixFooterButtons();
            });

        }, 2000);

    }, []);

    if (window.location.protocol !== 'https:' && !window.location.href.includes("localhost")) {
        return null;
    }


    if (!userRefreshed) {
        return null;
    }
    return (
        <Router/>
    );
}

export default App
